import React from 'react';
import { Button } from '../../../../third-party-components/kendo-react-ui';
import { isMobile } from 'react-device-detect';
import { isTouch } from '../../../../functions';

const TaskButton = ({children, onClick, selected, className='', imageUrl=""}) => (
    <div className={`task-button ${className}`}>
        <button imageUrl={imageUrl} className={((selected ? ' selected' : '') + (!isTouch() ? ' hover' : ''))} onClick={onClick} style={{ textTransform: "none" }}>
            {children}
        </button>
    </div>
)

export default TaskButton;